var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"manage-department-title"},[_vm._v(" "+_vm._s(_vm.titlename)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }